<template>
    <div
        class="flex gap-2 whitespace-nowrap items-center box-border p-2 cursor-pointer text-sm transition-all hover:bg-gray-200"
        :class="{ 'bg-blue-300': active }"
        @click="handleClick">
        <div class="flex flex-col w-full overflow-hidden">
            <p class="font-bold">
                <span>
                    {{ vehicle.licensePlate }}
                </span>
            </p>
            <template v-if="currentDriver">
                <hts-tooltip>
                    <template #reference>
                        <p>
                            <span>
                                {{ currentDriver.fullName }}
                            </span>
                            <span
                                v-if="currentDriver.phone?.number"
                                class="ml-1">
                                ({{ currentDriver.phone?.code }}) {{ currentDriver.phone?.number }}
                            </span>
                        </p>
                    </template>
                    <p>
                        <span>
                            {{ currentDriver.fullName }}
                        </span>
                        <span
                            v-if="currentDriver.phone?.number"
                            class="ml-1">
                            ({{ currentDriver.phone?.code }}) {{ currentDriver.phone?.number }}
                        </span>
                    </p>
                </hts-tooltip>
            </template>
        </div>
        <div
            v-if="infoType === 'partner'"
            class="flex flex-col w-full overflow-hidden">
            <div class="block">
                <p class="font-medium">
                    {{ vehicle.fleetVehicle?.name }}
                </p>
            </div>
        </div>
        <div
            v-else-if="infoType !== 'none'"
            class="flex flex-col w-full overflow-hidden">
            <div
                v-if="!vehicle?.processingJourney"
                class="block">
                <div class="flex items-center space-x-2">
                    <hts-icon-svg
                        v-if="vehicle?.containerType"
                        name="truck"
                        class-name="h-5 w-5" />
                    <hts-icon-svg
                        v-else
                        name="container"
                        class-name="h-5 w-5" />
                    <span class="font-bold">
                        {{ $formatters.formatCurrency(vehicle?.vehicleLoad) }} kg
                    </span>
                    <span
                        v-if="vehicle?.gpsInfo"
                        class="text-green-500 text-xs rounded border border-green-500 ml-1 px-1">
                        GPS ON
                    </span>
                    <span
                        v-else
                        class="text-error-500 text-xs rounded border border-error-500 ml-1 px-1">
                        GPS OFF
                    </span>
                </div>
                <div class="mt-1 w-full overflow-auto">
                    <hts-towing-names
                        class="text-ellipsis"
                        :items="vehicle.towingCapacity" />
                </div>
            </div>
            <div v-else>
                Journey: {{ vehicle?.processingJourney?.code }}
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
const { $dayjs } = useNuxtApp()
const { data } = $store()
const props = defineProps({
  vehicle: {
    type: Object,
    required: true
  },
  infoType: {
    type: String,
    default: 'vehicle'
  },
  active: Boolean
})
const emits = defineEmits(['click'])
const { vehicle } = toRefs(props)
const drivers = computed(() => data.drivers)
const currentDriver = computed<any>(() => drivers.value.find((d: any) => d._id === vehicle.value.driver))
const minLocationAt = computed(() => $dayjs().valueOf())
const checkLocationAt = (at: string) => {
  if (!at) {
    return false
  }
  return $dayjs(at) < minLocationAt.value
}
const handleClick = (e: any) => {
  emits('click', e)
}
</script>
